// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__zfln8","productName":"Table_productName__vmS20"};